import React from 'react';
import { Navigate } from 'react-router-dom';
import ROUTES from '@/routes/routes-enums';
import useMe from '@/services/auth/queries/useMe';
import { UserRole } from '@repo/common-types';

const SuperAdminRoute: React.FC<{
  component: React.ReactElement;
  redirectTo?: string;
}> = ({ component, redirectTo = ROUTES.AGENTS }) => {
  const { data, isLoading } = useMe();

  if (isLoading) {
    return <div className="text-muted p-3">Loading...</div>;
  }

  if (data?.role !== UserRole.SUPER_ADMIN) {
    return <Navigate to={redirectTo} replace />;
  }

  return component;
};

export default SuperAdminRoute;
